import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import IconButton from 'material-ui/IconButton';
import ArrowLeft from '../../Icons/ArrowLeft';
import StatusLabel from '../parts/StatusLabel';
import { connect } from 'react-redux';

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    backgroundColor: 'white',
    borderBottom: '1px solid  #D8DBDF',
  },

  content: {
    width: '100%',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    padding: '0px 15px',
    boxSizing: 'border-box'
  },

  backBtn: {
    margin: 0,
    borderRadius: '50%',
    minWidth: 'unset',
    fontSize: 13,
  },

  name: {
    color: '#181819',
    fontSize: '13px',
    fontWeight: 'bold'
  },

});

class GoBackAndLatestStatusSection extends React.Component {
  render() {
    const { classes, statuses } = this.props;

    let type;
    if (statuses && statuses.length > 0) {
      type = statuses[statuses.length - 1].status_label_type;
    }

    let backBtn = (
      <IconButton
        className={classes.backBtn}
        onClick={this.props.goBack}
        color="default"
        aria-label="Back">
        <ArrowLeft color="#B1B3B9" width={20} height={20} />
      </IconButton>
    )

    return (
      <div className={classes.root}>
        <div className={classes.content}>
          {backBtn}
          <div className={classes.name}>タイムライン</div>
          <div className="flex"></div>
          <StatusLabel type={type} />
        </div>
      </div>
    )
  }
}

GoBackAndLatestStatusSection.propTypes = {
  classes: PropTypes.object.isRequired,
  goBack: PropTypes.func.isRequired,
  statuses: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    statuses: state.timeline.statuses.toIndexedSeq().toArray(),
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(GoBackAndLatestStatusSection));



// WEBPACK FOOTER //
// ./src/components/Timeline/sections/GoBackAndLatestStatusSection.jsx